import React from 'react';
import _ from "lodash";
import FormGroupPlainText from "../formGroupPlainText";
import accounting from "accounting";
import { CURRENCY } from '../../helpers/variables';

const WizardClientDetails = (props) => {
    const firstArrayLength = Math.ceil(_.size(props.quoteQuestions.filter(question => {
        const answer = props._getQuestionAnswer(question.machineName);
        return !!answer
    })) / 2);
    const noteMessage = props._getQuoteMessageByPosition('QuickQuoteNotice');
    return (
        <div className={'row'}>
            <div className={'col-sm-6'}>
                <form className={'form-horizontal'}>
                    {
                        _.map(props.quoteQuestions, (question, index) => {
                            if(index > firstArrayLength - 1) {return null}
                            const answer = props._getQuestionAnswer(question.machineName);
                            if(!answer) {return null}
                            return (
                                <FormGroupPlainText
                                    key={question.id}
                                    leftWrapper="col-sm-6"
                                    Label={question.alternativeDisplayName?
                                        question.alternativeDisplayName:question.name}
                                    InputWrapper="manageSolicitorAccount-data col-sm-6"
                                    Text={
                                        question.inputType ===  'amount'?
                                            accounting.formatMoney(answer , `${CURRENCY} `, 2)
                                            :
                                            answer
                                    }
                                />
                            )
                        })
                    }
                </form>
            </div>
            <div className={'col-sm-6'}>
                <form className={'form-horizontal'}>
                    {
                        _.map(props.quoteQuestions, (question, index) => {
                            if(index <= firstArrayLength - 1) {return null}
                            const answer = props._getQuestionAnswer(question.machineName);
                            if(!answer) {return null}
                            return (
                                <FormGroupPlainText
                                    key={question.id}
                                    leftWrapper="col-sm-6"
                                    Label={question.alternativeDisplayName?
                                        question.alternativeDisplayName:question.name}
                                    InputWrapper="manageSolicitorAccount-data col-sm-6"
                                    Text={
                                        question.inputType ===  'amount'?
                                            accounting.formatMoney(answer , `${CURRENCY} `, 2)
                                            :
                                            answer
                                    }
                                />
                            )
                        })
                    }
                </form>
            </div>
            <div className={'col-sm-12'} dangerouslySetInnerHTML={{__html: noteMessage.body}}>
            </div>
        </div>
    )
};

export default WizardClientDetails;
